import { BackButton } from "@publicPortal/components/BackButton/BackButton";
import Field from "@mirage/components/regularField/Field";
import { Tabs, Tab, Grid } from "@mui/material";
import Board from "@publicPortal/components/board/Board";
import ResponsiveAppBar from "@publicPortal/components/responsiveAppBar/ResponsiveAppBar";
import CompetentPersonsSchemeService from "@publicPortal/services/CompetentPersonsSchemeService";
import { RecordDetailsTabNames } from "@publicPortal/utils/enums";
import { IBcCompetentPersonSchema } from "@shared/publicportal/entities/IBcCompetentPersonSchema";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const service = new CompetentPersonsSchemeService();

const CompetentPersonsScheme = () => {
    const { id } = useParams();
    const [schema, setSchema] = useState<IBcCompetentPersonSchema | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        service.getSchemeById(Number(id)).then((response) => {
            if (!response) {
                setLoading(false);
                return;
            }
            setSchema(response);
            setLoading(false);
        });
    }, [id]);

    return (
        <>
            <ResponsiveAppBar />
            <Board headerText={"Competent Persons Scheme " + (schema?.uniqueId || "not found")} size="big" loadingHeaderText={loading}>
                <BackButton />
                <CompetentPersonsSchemeTabs recordId={schema?.id} />
                <CompetentPersonsSchemeSummaryTabContent schema={schema} loading={loading} />
            </Board>
        </>
    );
};

const CompetentPersonsSchemeTabs: React.FC<{ recordId?: number }> = ({ recordId }) => {
    if (recordId) {
        return (
            <Tabs aria-label="Enforcement Appeal Navigation Tabs" sx={{ margin: "2rem 0 3rem 0" }} value={RecordDetailsTabNames.Summary}>
                <Tab key={`${RecordDetailsTabNames.Summary}-key`} disableRipple label={RecordDetailsTabNames.Summary} value={RecordDetailsTabNames.Summary} />;
            </Tabs>
        );
    }
    return null;
};

const CompetentPersonsSchemeSummaryTabContent: React.FC<{ schema: IBcCompetentPersonSchema | null; loading: boolean }> = ({ schema, loading }) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={6} xl={6}>
                <Grid item>
                    <Field label="Description Of Work" mode="view" value={schema?.descriptionOfWork} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Type Of Property" mode="view" value={schema?.typeOfProperty} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Address" mode="view" value={schema?.address} isLoading={loading} contentType="TEXTAREA" />
                </Grid>
                <Grid item>
                    <Field label="Post Code" mode="view" value={schema?.postcode} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Post Town" mode="view" value={schema?.postTown} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Easting" mode="view" value={schema?.easting} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Northing" mode="view" value={schema?.northing} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="UPRN" mode="view" value={schema?.uprn} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Commissioning Required" mode="view" value={schema?.commissioningRequired} isLoading={loading} contentType="CHECKBOX" />
                </Grid>
                <Grid item>
                    <Field label="Commissioning Carried Out" mode="view" value={schema?.commissioningCarriedOut} isLoading={loading} contentType="CHECKBOX" />
                </Grid>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
                <Grid item>
                    <Field label="Scheme" mode="view" value={schema?.scheme} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Unique ID" mode="view" value={schema?.uniqueId} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Local Authority Code" mode="view" value={schema?.localAuthorityCode} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Person Registration Identifier" mode="view" value={schema?.personRegistrationIdentifier} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Installer Registered Name" mode="view" value={schema?.installerRegisteredName} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Certificate Reference" mode="view" value={schema?.certificateReference} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Contact Telephone Number" mode="view" value={schema?.contactTelephoneNumber} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Sender Response Email" mode="view" value={schema?.senderResponseEmail} isLoading={loading} contentType="TEXT" />
                </Grid>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
                <Grid item>
                    <Field label="Date Work Started" mode="view" value={schema?.dateWorkCommenced} isLoading={loading} contentType="DATE" />
                </Grid>
                <Grid item>
                    <Field label="Date Work Completed" mode="view" value={schema?.dateWorkCompleted} isLoading={loading} contentType="DATE" />
                </Grid>
            </Grid>
        </Grid>
    );
};

type CompetentPersonsSchemeTabs = RecordDetailsTabNames.Summary;

export default CompetentPersonsScheme;
